import { styled } from '@linaria/react';
import { m } from 'framer-motion';
import { COLORS } from '@livecommerce/design-system';
import Labels from 'components/Labels/index.jsx';

export const StyledDrawer = styled(m.div)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  max-width: 100%;
  overflow: hidden;
`;

export const StyledLabels = styled(Labels)`
`;

export const DrawerTopbar = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${COLORS.light_300};
  padding: 16px 16px 8px;
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export const DrawerContent = styled.div`
  position: ${(props) => props.scrollDrawerContent ? 'relative' : 'static'};
  width: ${(props) => props.scrollDrawerContent ? '100%' : 'auto'};
  height: ${(props) => props.scrollDrawerContent ? '100%' : 'auto'};
  overflow-y: ${(props) => props.scrollDrawerContent ? 'auto' : 'hidden'};
  flex: ${(props) => props.scrollDrawerContent ? 'initial' : '1 1 0px'};
`;

export const DrawerFooter = styled.div`
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 16px 16px;
  border-top: 1px solid ${COLORS.light_300};
`;

export const FirstLevelDrawer = styled.div`
  border-radius: 16px;
  background-color: ${COLORS.white};
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: opacity 0.25s, transform 0.25s;
  opacity: ${(props) => props.fadedOut ? '0.5' : '1'};
  transform: ${(props) => props.fadedOut ? 'scale(0.95)' : 'scale(1)'};
  transform-origin: top;
  overflow-y: ${(props) => props.scrollDrawerContent ? 'visible' : 'auto'};
`;

export const SecondLevelDrawer = styled.div`
  border-radius: 16px;
  background-color: ${COLORS.white};
  padding: 0;
  display: flex;
  flex-direction: column;
  transform-origin: top;
  position: absolute;
  top: 24px;
  width: 100%;
  height: calc(100% - 24px);
`;

export const AnimatedSecondLevelDrawer = m(SecondLevelDrawer);
